import script from "./DatasetSearchUI.vue?vue&type=script&setup=true&lang=js"
export * from "./DatasetSearchUI.vue?vue&type=script&setup=true&lang=js"

import "./DatasetSearchUI.vue?vue&type=style&index=0&id=5c09c51c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c09c51c"]])

export default __exports__